// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropdownButtonIcon_icon__MSXjG","icon_container":"DropdownButtonIcon_icon_container__6ZD8n"};